export const dataAttribute = (name: string, attribute: string) => ({
  default: null,
  parseHTML: (element: HTMLElement) => element.getAttribute(attribute),
  renderHTML: (attributes: Record<string, unknown>) =>
    attributes[name] ? { [attribute]: attributes[name] } : {},
});
